"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
const react_1 = __importDefault(require("react"));
const use_field_api_1 = __importDefault(require("@data-driven-forms/react-form-renderer/use-field-api"));
const Toggle_1 = __importDefault(require("../../../Toggle"));
const FormField_1 = __importDefault(require("../../../FormField"));
const useUniqueId_1 = __importDefault(require("../../../../hooks/useUniqueId"));
const SwitchMapping = (props) => {
    const _a = use_field_api_1.default(props), { label, description, isDisabled, initialValue, input } = _a, rest = __rest(_a, ["label", "description", "isDisabled", "initialValue", "input"]);
    const controlId = useUniqueId_1.default(input.name);
    return (react_1.default.createElement(FormField_1.default, { controlId: controlId },
        react_1.default.createElement(Toggle_1.default, Object.assign({}, rest, input, { label: label, checked: !!input.value, description: description, controlId: input.name, disabled: isDisabled, name: input.name }))));
};
exports.default = SwitchMapping;
//# sourceMappingURL=index.js.map